import React, { useRef, useState } from "react";
import { BreadCrumb } from "../components/BreadCrumb";
import ReCAPTCHA from "react-google-recaptcha";
import { verifyRecaptcha } from "../../actions/home";

export const LibroReclamaciones = () => {

    const [captchaValue, setCaptchaValue] = useState(null)
    const recaptchaRef = useRef()

    const handleCaptchaChange = (value) => {
        setCaptchaValue(value)
        console.log("Valor de reCaptcha: ", value)
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!captchaValue) {
            alert("Por favor, verifica que no eres un robot")
            return
        }

        const isValid = await verifyRecaptcha(captchaValue)
        if (isValid) {
            console.log("reCaptcha validado")
        } else {
            console.log("Error en la validación")
        }
    }

    return (
        <div className="container-libro-reclamaciones font-family-montserrat">
            <div style={{ marginBottom: '25px' }}>
                <BreadCrumb productoNombre="Libro de Reclamaciones" />
            </div>
            <h2 className="title-libro-reclamaciones">Libro de Reclamaciones</h2>
            <form action="" className="form-libro-reclamaciones">

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="nombres">Nombres</label>
                        <input type="text" id="nombres" name="nombres" required className="input-libro-reclamaciones" pattern="[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="apellidos">Apellidos</label>
                        <input type="text" id="apellidos" name="apellidos" required className="input-libro-reclamaciones" pattern="[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+" />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="tipoDocumento">Tipo de Documento</label>
                        <select id="tipoDocumento" name="tipoDocumento" required className="select-libro-reclamaciones">
                            <option value="">[Seleccione]</option>
                            <option value="dni">DNI</option>
                            <option value="pasaporte">Pasaporte</option>
                            {/* Otras opciones */}
                        </select>
                    </div>
                    <div className="form-group">
                        <label htmlFor="numeroDocumento">Número de Documento</label>
                        <input type="number" id="numeroDocumento" name="numeroDocumento" required className="input-libro-reclamaciones" />
                    </div>
                </div>


                <div className="form-row">
                    <div className="form-group form-group--full">
                        <label htmlFor="correo">Correo</label>
                        <input type="email" id="correo" name="correo" required className="input-libro-reclamaciones" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="telefono">Teléfono</label>
                        <input type="number" id="telefono" name="telefono" required className="input-libro-reclamaciones" pattern="[0-9]+" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="direccion">Dirección</label>
                        <input type="text" id="direccion" name="direccion" required className="input-libro-reclamaciones" />
                    </div>
                </div>

                <div className="form-group form-group--full">
                    <label htmlFor="nombrePadreMadre">Nombre del padre o madre (En caso sea menor de edad)</label>
                    <input type="text" id="nombrePadreMadre" name="nombrePadreMadre" className="input-libro-reclamaciones" pattern="[A-Za-zÁÉÍÓÚáéíóúÑñ\s]+" title="Solo se permiten letras" />
                </div>

                <div className="form-row">
                    <div className="form-group form-group--full">
                        <label htmlFor="datosBien" ><strong>Ingrese los datos del bien contratado</strong></label>
                        <label htmlFor="datosBienProducto" className="flex-container align-center">
                            <input
                                type="radio"
                                id="datosBienProducto"
                                name="datosBien"
                                value="producto"
                                required
                            />
                            Producto
                        </label>
                        <label htmlFor="datosBienServicio" className="flex-container align-center">
                            <input
                                type="radio"
                                id="datosBienServicio"
                                name="datosBien"
                                value="servicio"
                                required
                            />
                            Servicio
                        </label>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="montoReclamado">Monto reclamado</label>
                        <input type="number" id="montoReclamado" name="montoReclamado" required className="input-libro-reclamaciones" />
                    </div>
                    <div className="form-group">
                        <label htmlFor="comprobanteTipo">Comprobante</label>
                        <select id="tipoDocumento" name="tipoDocumento" required className="select-libro-reclamaciones">
                            <option value="">[Seleccione]</option>
                            <option value="dni">Factura</option>
                            <option value="pasaporte">Boleta</option>
                        </select>
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group" style={{ flex: "1" }}>
                        <label htmlFor="numeroComprobante">Número de comprobante</label>
                        <input type="text" id="numeroComprobante" name="numeroComprobante" className="input-libro-reclamaciones" />
                    </div>
                    <div className="form-group" style={{ flex: "1" }}>
                        <label htmlFor="fechaComprobante">Fecha de comprobante</label>
                        <input type="date" id="fechaComprobante" name="fechaComprobante" className="input-libro-reclamaciones" style={{ width: '100%' }} />
                    </div>
                </div>

                <div className="form-group form-group--full">
                    <label htmlFor="descripcion">Descripción</label>
                    <textarea
                        id="descripcion"
                        name="descripcion"
                        rows="3"
                        className="textarea-primary"
                        style={{
                            border: '1px solid #C0C0C0',
                            borderRadius: '5px',
                            resize: 'none',
                            width: '100%'
                        }}></textarea>
                </div>

                <div className="form-group form-group--full">
                    <label htmlFor="detallesReclamacion">
                        <strong>Ingrese los detalles de la reclamación y pedido</strong>
                    </label>
                    <label htmlFor="detallesReclamacionReclamo" className="flex-container align-center">
                        <input
                            type="radio"
                            id="detallesReclamacionReclamo"
                            name="detallesReclamacion"
                            value="reclamo"
                            required
                        />
                        Reclamo (1)
                    </label>
                    <label htmlFor="detallesReclamacionQueja" className="flex-container align-center">
                        <input
                            type="radio"
                            id="detallesReclamacionQueja"
                            name="detallesReclamacion"
                            value="queja"
                            required
                        />
                        Queja (2)
                    </label>
                </div>

                <div className="form-group form-group--full">
                    <label htmlFor="detalles">Detalles</label>
                    <textarea
                        id="detalles"
                        name="detalles"
                        rows="3"
                        className="textarea-secundary"
                        style={{
                            border: '1px solid #C0C0C0',
                            borderRadius: '5px',
                            resize: 'none',
                            width: '100%'
                        }}></textarea>
                </div>

                <div className="form-group form-group--full">
                    <label htmlFor="pedido">Pedido</label>
                    <textarea
                        id="pedido"
                        name="pedido"
                        rows="3"
                        className="textarea-secundary"
                        style={{
                            border: '1px solid #C0C0C0',
                            borderRadius: '5px',
                            resize: 'none',
                            width: '100%'
                        }}></textarea>
                </div>

                <div className="form-group form-group--full">
                    <label htmlFor="acciones">
                        <strong>Ingrese la acción tomada por nuestro representante</strong>
                    </label>
                    <textarea
                        id="acciones"
                        name="acciones"
                        rows="3"
                        className="textarea-secundary"
                        style={{
                            border: '1px solid #C0C0C0',
                            borderRadius: '5px',
                            resize: 'none',
                            width: '100%'
                        }}></textarea>
                </div>

                <div class="reclamaciones-container" style={{ boxSizing: 'border-box' }}>
                    <div class="reclamaciones-tipo">
                        <p>(1) ={'>'} Disconformidad relacionada a los productos o servicios</p>
                        <p>(2) ={'>'} Disconformidad no relacionada a los productos o servicios; o, malestar o descontento respecto a la atención al público.</p>
                    </div>

                    <div class="captcha-container" style={{marginBottom: '20px'}}>
                            <ReCAPTCHA
                            sitekey="6Lci6gUrAAAAAKfjM7t1_AliRF9_747-l_dKFItx"
                            onChange={handleCaptchaChange}
                            data-size="compact"
                            />
                        </div>

                    <div className="container-btn-submit" style={{ display: 'flex', justifyContent: 'end' }}>
                        <div class="btn-submit">ENVIAR</div>
                    </div>
                </div>
            </form>
        </div>
    )
}